import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { AppService } from 'src/app/app.service';
import { AssetService } from 'src/app/services/asset.service';
import { AuthService } from 'src/app/services/auth.service';
import { PaymentService } from 'src/app/services/payment.service';
import { TransferService } from 'src/app/services/transfer.service';
import { TransferCreateComponent } from '../transfer-create/transfer-create.component';

@Component({
  selector: 'app-mes-avoirs',
  templateUrl: './mes-avoirs.component.html',
  styleUrls: ['./mes-avoirs.component.scss']
})
export class MesAvoirsComponent implements OnInit, OnDestroy {

  //Subscription
  assetSubscription: Subscription;
  sumTransfer: Subscription;
  currentAmountSubscription: Subscription;

  //Boolean
  assetGetted: boolean;
  sumTransferGetted: boolean;
  currentAmountGetted: boolean;

  //Other
  user: any;
  sum: number;
  transferTotal: number;
  currentAmount: number;
  sumPaymentWithAsset: number;
  avoirs: any[];

  public viewType: string = "list";
  public column: number = 4;
  public p: number = 1;

  //outPut
  valueChange: boolean;

  currency: string;

  displayedColumns: string[] = ['id', 'amount', 'location', 'vehicle',  'date'];
  dataSource!: MatTableDataSource<any>;
  @ViewChild(MatPaginator, {static: false}) paginator!: MatPaginator;
  @ViewChild(MatSort, {static: false}) sort!: MatSort;


  constructor(private assetService: AssetService,
              private authService: AuthService,
              private router: Router, 
              private transferService: TransferService,
              private appService: AppService,
              private paymentService: PaymentService) { }

  ngOnInit(): void {

    this.currency = this.appService.getCurrency();

    let res = this.authService.getUserOfLocalStorage();
    
    if(res.status) {

      this.user = JSON.parse(localStorage.getItem("user")!)
 
      this.getAssets();
      this.getAmount();

    } else {

      this.assetGetted = false;
      this.sumTransferGetted = false;
      this.currentAmountGetted = false;
      

      this.router.navigate(['login']);

    }

    this.valueChange = false;

  }

  getAssets() {

    this.assetSubscription = this.assetService.assetOfUser(this.user.id).subscribe((response: any) => {

      console.log(response);

      this.sum = response.sum;
      this.sumPaymentWithAsset = response.sumPaymentWithAsset
      this.avoirs=response.assets;
      this.dataSource = new MatTableDataSource(response.assets);
      this.dataSource.paginator = this.paginator;
      this.dataSource.sort = this.sort;

    });
  }

  getAmount() {

    let obj = {
      'idUser': this.user.id,
      'key': 'ASSET'
    }

    //Total virements
    this.sumTransfer = this.transferService.sumTransfer(obj).subscribe((data: any) => {

      this.transferTotal = data.value;

      this.sumTransferGetted = true;
      
    })


    //Montant actuel
    this.currentAmountSubscription = this.paymentService.currentAmount(obj).subscribe((data: any) => {
      
      this.currentAmount = data.value;

      this.currentAmountGetted = true;

    })
  }

  /**
   * Enregistrement d'une demande de virement
   */
  public createTransfer() {

    let data = {
      amount: this.currentAmount,
      idUser: this.user.id,
      key: 'ASSET'
    } 

    const dialogRef = this.appService.openDialog(TransferCreateComponent, data, 'theme-dialog');

    dialogRef.afterClosed().subscribe((res) => {
      
      this.getAmount();

      this.valueChange = true;

    })

  }

  ngOnDestroy(): void {
    
    if(this.assetGetted) {

      this.assetSubscription.unsubscribe();

    }

    if(this.sumTransferGetted) {

      this.sumTransfer.unsubscribe();

    }

    if(this.currentAmountGetted) {

      this.currentAmountSubscription.unsubscribe();

    }

  }

  
  public refresh(){
    this.getAssets();
  }
 
  changeViewType(viewType:string)
  {
    this.viewType = viewType;
  }


}
